import { Point } from '../math/point'
import { Viewport } from '../game/view-transform'
import clone from 'immutability-helper'
import { Rectangle } from '../math/rectangle'
import { Size } from '../math/size'

// TODO: fix world grid rectangle
export class WorldGrid extends Viewport {
  /**
   * world grid with aspect ratio 1:1
   * @param squares length of viewable world in number of squares
   * @param step length of the space in a single square of the grid in world coordinates
   */
  constructor(readonly squares: number, readonly step: number) {
    super(squares * step, new Point(0,0))
  }

  rectangle(): Rectangle {
    const length2 = this.length/2
    return new Rectangle(new Point(-length2, -length2), new Size(this.length))
  }

  setOrigin(newOrigin: Point): WorldGrid {
    return clone(this as WorldGrid, {origin: {$set: newOrigin}})
  }

  toGridScalar(length: number): number {
    return Math.round(length / this.step)
  }

  toGrid(p: Point): Point {
    return p.map(a => this.toGridScalar(a))
  }

  toWorld(p: Point): Point {
    return p.scale(this.step)
  }

  snap(p: Point): Point {
    const p1 = this.toGrid(p)
    const p2 = this.toWorld(p1)
    return p2
  }
}
